import { createSlice } from '@reduxjs/toolkit'
import {
    DEFAULT_CURRENCY,
    getCountryCurrency,
    isSupportedCountryCode
} from '../../config/countries';

/** Devise d'un pays : référentiel backend s'il est chargé, table locale sinon (jamais EUR par repli). */
const countryCurrency = (referential, code) => {
    if (!code) return DEFAULT_CURRENCY;
    return referential?.[code.toUpperCase()]?.currency ?? getCountryCurrency(code);
};

const initialState = {

    // EXISTANT → ne pas toucher
    country: {
        label: "Nigeria",
        value: "NG"
    },

    // NOUVEAUX CHAMPS
    residenceCountry: null,

    activityCountry: {
        label: "Nigeria",
        value: "NG"
    },

    // Devise du pays d'activité : référentiel backend (GET /countries) dès
    // qu'il est chargé, src/config/countries.js en attendant, XOF tant que le
    // pays n'est pas résolu.
    currency: DEFAULT_CURRENCY,

    // Référentiel pays → devise de assiganto-commercial-financial-platform
    // (source de vérité) : { [code pays]: { currency, symbol, minorUnits, supported } }.
    currencyReferential: null,

    type: {
        isSupportedCountry: false,
        isCountryInProgressSupport: false,
    }
}

export const countrySlice = createSlice({

    name: 'country',

    initialState,

    reducers: {

        // EXISTANT → inchangé
        editCountry: (state, action) => {

            const payload = action.payload;

            if (
                payload &&
                typeof payload === 'object' &&
                'label' in payload &&
                'value' in payload
            ) {

                state.country = payload;

                const code = payload.value;

                state.type = {

                    isSupportedCountry:
                        isSupportedCountryCode(code),

                    isCountryInProgressSupport: false,

                };

            } else {

                console.warn(
                    'editCountry payload invalide:',
                    payload
                );

            }

        },

        // NOUVEAU
        setResidenceCountry: (state, action) => {

            state.residenceCountry =
                action.payload;
        },

        // NOUVEAU
        setActivityCountry: (state, action) => {

            state.activityCountry =
                action.payload;

            state.currency = countryCurrency(state.currencyReferential, action.payload?.value);

        },

        // Référentiel backend (GET /countries) : il prime sur la table locale.
        setCurrencyReferential: (state, action) => {

            state.currencyReferential = Object.fromEntries(
                (action.payload || []).map(country => [country.code, {
                    currency: country.currency.code,
                    symbol: country.currency.symbol,
                    minorUnits: country.currency.minorUnits,
                    supported: country.supported
                }])
            );

            state.currency = countryCurrency(state.currencyReferential, state.activityCountry?.value);

        }

    }

})

export const {

    editCountry,

    setResidenceCountry,

    setActivityCountry,

    setCurrencyReferential

} = countrySlice.actions

/**
 * Devise de contexte. Repli sur le pays d'activité quand l'état persisté
 * date d'avant l'ajout du champ `currency`.
 */
export const selectCurrency = state =>
    state.country?.currency ??
    countryCurrency(state.country?.currencyReferential, state.country?.activityCountry?.value)

/** Symbole d'une devise selon le référentiel backend, null s'il n'est pas (encore) chargé. */
export const selectBackendCurrencySymbol = (state, currency) =>
    Object.values(state.country?.currencyReferential || {})
        .find(entry => entry.currency === currency)?.symbol ?? null

export default countrySlice.reducer